export const ACTION_MASTERDATA_START = 'ACTION_MASTERDATA_START';
export const ACTION_MASTERDATA_END = 'ACTION_MASTERDATA_END';
export const STORE_LOCATIONS = 'STORE_LOCATIONS';
export const STORE_CITY = 'STORE_CITY';
export const STORE_REGION = 'STORE_REGION';
export const SEARCH_STORES = 'SEARCH_STORES';
export const SAVED_STORES = 'SAVED_STORES';
export const STORE_STATE = 'STORE_STATE';
export const STORE_ZONE = 'STORE_ZONE';
export const STORE_PARENT_ZONE = 'STORE_ PARENT_ZONE';
export const UPDATE_STORES = 'UPDATE_STORES';
export const GET_LOCATION_COUNT = 'GET_LOCATION_COUNT';
export const GET_CITY_COUNT = 'GET_CITY_COUNT';
export const GET_STATE_COUNT = 'GET_STATE_COUNT';
export const GET_ZONE_COUNT = 'GET_ZONE_COUNT';
export const SAVED_CITIES = 'SAVED_CITIES';
export const UPDATE_CITIES = 'UPDATE_CITIES';
export const SAVED_STATE = 'SAVED_STATE';
export const UPDATE_STATE = 'UPDATE_STATE';
export const SAVED_ZONE = 'SAVED_ZONE';
export const UPDATE_ZONE = 'UPDATE_ZONE';
export const GET_SERVICE_NAME = 'GET_SERVICE_NAME';
export const GET_SERVICE_PRICE = 'GET_SERVICE_PRICE';
export const SAVE_SERVICE_PRICE = 'SAVE_SERVICE_PRICE';
export const UPDATE_SERVICE_PRICE = 'UPDATE_SERVICE_PRICE';
export const GET_LOCATION_DATA = 'GET_LOCATION_DATA';
export const SAVED_FILES = 'SAVED_FILES';
export const C2C_ZONE = 'C2C_ZONE';
export const ACTION_ZONE_START = 'ACTION_MASTERDATA_START';
export const ACTION_ZONE_END = 'ACTION_MASTERDATA_END';
export const GET_ZONE_DATA = 'GET_ZONE_DATA';
export const LOCATION_BASED_ZONE = 'LOCATION_BASED_ZONE';
export const STORE_PINCODE = 'STORE_PINCODE';
export const GET_PINCODE_COUNT = 'GET_PINCODE_COUNT';
export const GET_INTERCITY_COUNT = 'GET_INTERCITY_COUNT';
export const STORE_INTERCITY = 'STORE_INTERCITY';
export const FETCHING_INTERCITY_ROUTE_LIST = 'FETCHING_INTERCITY_ROUTE_LIST';
export const FETCHED_INTERCITY_ROUTE_LIST = 'FETCHED_INTERCITY_ROUTE_LIST';
export const SAVED_INTERCITY_ROUTE = 'SAVED_INTERCITY_ROUTE';
export const UPDATED_INTERCITY_ROUTE = 'UPDATED_INTERCITY_ROUTE';

export const GET_DRIVER_COUNT = 'GET_DRIVER_COUNT';
export const SEARCH_DRIVERS = 'SEARCH_DRIVERS';
export const SAVED_DRIVER = 'SAVED_DRIVER';
export const UPDATE_DRIVER = 'UPDATE_DRIVER';

export const GET_MAKE_LIST = 'GET_MAKE_LIST';
export const SEARCH_MAKE_LIST = 'SEARCH_MAKE_LIST';

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
